<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-md-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Fornecedores
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Cadastrar Fornecedor
                        </ng-template>
                        <!-- CADASATRANDO OBJETO INICIO -->
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <!--passa qual é o formulario e o evento-->
                                <div class="row">
                                    <div class="col-12 col-md-1">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>ID</mat-label>
                                            <input formControlName="id" matInput readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Nome Fantasia</mat-label>
                                            <input formControlName="nomeFantasia" matInput placeholder="Digite seu nome"
                                                minlength="3" maxlength="250" required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Razão Social</mat-label>
                                            <input formControlName="razaoSocial" matInput placeholder="Digite seu nome"
                                                minlength="3" maxlength="250" required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Telefone</mat-label>
                                            <input formControlName="telephone" matInput placeholder="(99)9999-9999"
                                                mask="(00) 0 0000-0000 || (00) 0000-0000" required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>CEP</mat-label>
                                            <input id="cep" name="cep" formControlName="cep" mask="00000-000" matInput
                                                (blur)="buscarDadosCep()" required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Estado</mat-label>
                                            <mat-select id="estado" name="estado" formControlName="estado" required>
                                                <mat-option [value]="estado"
                                                    *ngFor="let estado of estados">{{getSiglaEstado(estado)}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Endereço</mat-label>
                                            <input formControlName="address" matInput placeholder="Digite seu endereço"
                                                required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Quadra</mat-label>
                                            <input formControlName="block" matInput placeholder="Digite sua quadra"
                                                required>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-12 col-md-2">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Lote</mat-label>
                                            <input formControlName="batch" matInput placeholder="Digite seu lote"
                                                required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Complemento</mat-label>
                                            <input formControlName="complement" matInput placeholder="Complemento">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-12 col-md-4">
                                        <mat-form-field appearance="fill" class="w-100">
                                            <mat-label>Bairro</mat-label>
                                            <input id="bairro" name="bairro" matInput formControlName="bairro" required>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-12 col-md-4">
                                        <mat-form-field appearance="fill" class="w-100">
                                            <mat-label>Cidade</mat-label>
                                            <input id="cidade" name="cidade" formControlName="cidade" matInput>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-12 col-md-12">
                                        <mat-form-field class="full-width" appearance="fill" class="w-100">
                                            <mat-label>Observação</mat-label>
                                            <textarea formControlName="observation" matInput
                                                placeholder="Observação"></textarea>
                                        </mat-form-field>
                                    </div>


                                </div>

                                <div class="row justify-content-between">
                                    <div class="col-12 col-md-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-12 col-md-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div class="esp-top">
                                <!-- verifica se tem erros no preenchimento do campo e se inicio o preenchimento -->
                                <div *ngIf="formulario.controls.razaoSocial.errors && !formulario.controls.razaoSocial.pristine"
                                    class="alert alert-warning" role="alert">
                                    Campo nome deve conter entre 3 e 250 caracteres!
                                </div>

                            </div>
                        </mat-card>
                    </mat-tab>
                    <!-- CADASATRANDO OBJETO INICIO -->

                    <!-- LISTANDO TODAS INICIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Fornecedores
                        </ng-template>
                        <mat-card>

                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Consulta Por</mat-label>
                                        <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                            <mat-option [value]="tipoFiltro"
                                                *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-12 col-md-6">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Parâmetro de Consulta</mat-label>
                                        <input [(ngModel)]="parametroConsulta" name="parametroConsulta" matInput>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 col-md-2">
                                    <button (click)="consultar()" mat-raised-button color="primary"
                                        style="line-height: 51px;width: 100%;">
                                        <mat-icon>search</mat-icon>
                                        Consultar
                                    </button>
                                </div>

                            </div>

                            <!-- //inicio da tabela -->
                            <table mat-table [dataSource]="fornecedores" class="full-width">
                                <!-- Coluna ID -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.id }} </td>
                                </ng-container>

                                <!-- Coluna Nome -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Nome Fantasia </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.nomeFantasia }} </td>
                                </ng-container>

                                <ng-container matColumnDef="telephone">
                                    <th mat-header-cell *matHeaderCellDef> Telefone </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.telephone }} </td>
                                </ng-container>

                                <ng-container matColumnDef="address">
                                    <th mat-header-cell *matHeaderCellDef> Endereço </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.address }} </td>
                                </ng-container>

                                <ng-container matColumnDef="block">
                                    <th mat-header-cell *matHeaderCellDef> Quadra </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.block }} </td>
                                </ng-container>

                                <ng-container matColumnDef="batch">
                                    <th mat-header-cell *matHeaderCellDef> Lote </th>
                                    <td mat-cell *matCellDef="let fornecedor"> {{ fornecedor.batch }} </td>
                                </ng-container>

                                <ng-container matColumnDef="excluir">
                                    <th mat-header-cell *matHeaderCellDef> Excluir </th>
                                    <td mat-cell *matCellDef="let fornecedor">
                                        <button (click)="openDialog(fornecedor.id)" mat-icon-button color="warn">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="editar">
                                    <th mat-header-cell *matHeaderCellDef>Editar</th>
                                    <td mat-cell *matCellDef="let fornecedor">
                                        <button (click)="editar(fornecedor.id)" (click)="tabGroup.selectedIndex = 0"
                                            mat-icon-button color="accent">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>

                            <!-- paginação -->
                            <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                <!-- evento de paginar -->
                            </mat-paginator>

                        </mat-card>
                    </mat-tab>
                    <!-- LISTANDO TODAS FIM -->
                </mat-tab-group>
            </mat-card>
        </div>
    </div>

</main>